export const deeplink_sections = {
  APPOINTMENTS: 'appointments',
  MESSAGES: 'messages'
};
